import TableHasPagenation from '../../../components/TableHasPagenation'
import { Table, Tooltip } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import EditableCell from '../../../components/EditTableCell'
import EditableRow from '../../../components/EditableRow'
const maxCount = 999999999
const components = {
  body: {
    row: EditableRow,
    cell: EditableCell
  }
}
const styleDiffMap = {
  0: {
    color: '#FA4B54'
  },
  1: {
    color: '#006F5B'
  }
}
export default function CheckProductList({
  operateColums = [],
  page = false,
  pageData = {},
  getList = () => {},
  editDataIndex = '',
  handleSave = () => {},
  edit = false,
  list = []
}) {
  const Columns = [
    {
      title: '商品信息',
      dataIndex: 'productName',
      render: (text, record) => {
        return (
          <div style={{ fontSize: 12 }}>
            <div style={{ color: '#1890ff' }}>{record.productName}</div>
            <div>商品编码：{record.skuNo}</div>
            <div>商品条码：{record.barcode}</div>
          </div>
        )
      }
    },
    {
      title: '商品类别',
      dataIndex: 'categoryName'
    },
    {
      title: '规格',
      dataIndex: 'spec'
    },
    {
      title: '单位',
      dataIndex: 'unit'
    },
    {
      title: '系统库存',
      dataIndex: 'productStock'
    },
    {
      title: '盘点数量',
      dataIndex: 'checkStock',
      formatter: val => {
        val = val && Math.abs(parseInt(val))
        if (val) {
          return val > maxCount ? maxCount : val
        }
      }
    },
    {
      title: '盘点差异',
      dataIndex: 'checkDiffer',
      render: (text, record) => {
        let _differ = record.productStock - record.checkStock
        return _differ == 0 ? (
          0
        ) : (
          <span style={_differ > 0 ? styleDiffMap[0] : styleDiffMap[1]}>
            {Math.abs(_differ)}
          </span>
        )
      }
    },
    {
      title: () => (
        <Tooltip title='移动平均价'>
          <div>
            <span style={{ marginRight: '6px' }}>成本价</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'costPrice'
    },
    {
      title:  () => (
        <Tooltip title='成本总额=盘点数量*成本价'>
          <div>
            <span style={{ marginRight: '6px' }}>成本总额</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'costAmount',
      render: (text, record) => (record.checkStock * record.costPrice).toFixed(2)
    },
    {
      title:  () => (
        <Tooltip title='盈亏总额=盘点差异*成本价'>
          <div>
            <span style={{ marginRight: '6px' }}>盈亏总额</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'checkDifferCosePrice',
      render:(text, record)=>{
        let _checkDifferCosePrice = ((record.checkStock - record.productStock) *record.costPrice).toFixed(2)
        return _checkDifferCosePrice == 0 ? (
          '--'
        ) : _checkDifferCosePrice > 0 ? (
          <span style={styleDiffMap[1]}>{Math.abs(_checkDifferCosePrice)}</span>
        ) : (
          <span style={styleDiffMap[0]}>{Math.abs(_checkDifferCosePrice)}</span>
        )
      }
    },
    {
      title: '类型',
      dataIndex: 'checkDiffer',
      render: (text, record) => {
        let _differ = record.checkStock - record.productStock
        return _differ == 0 ? (
          '--'
        ) : _differ > 0 ? (
          <span style={styleDiffMap[1]}>盘盈</span>
        ) : (
          <span style={styleDiffMap[0]}>盘亏</span>
        )
      }
    }
  ]
  const keyList = Columns.map(item => item.dataIndex)
  let finalColumns = operateColums.length
    ? [...Columns, ...operateColums]
    : Columns
  const editColumnIndex = keyList.indexOf(editDataIndex)
  if (editDataIndex) {
    finalColumns[editColumnIndex].onCell = record => {
      return {
        record,
        editable: true,
        dataIndex: finalColumns[editColumnIndex].dataIndex,
        title: finalColumns[editColumnIndex].title,
        handleSave: handleSave,
        inputFormatter: finalColumns[editColumnIndex].formatter
      }
    }
  }
  return page ? (
    <TableHasPagenation
      pageData={pageData}
      components={components}
      rowKey='barcode'
      onPageSizeChange={getList}
      columns={finalColumns}
    />
  ) : (
    <Table
      rowKey='barcode'
      columns={finalColumns}
      dataSource={list}
      pagination={null}
    />
  )
}
